import React, { memo } from 'react';
import { LoadingIndicator, Placeholder } from '@fupa/fupa-uikit';
import DistrictLink from 'app/components/region/DistrictLink';
import styled from 'styled-components';
const StyledList = styled.ul.withConfig({
  componentId: "sc-q72ybm-0"
})(["list-style-type:none;margin:0;margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;padding-inline-start:0;"]);
const DistrictList = /*#__PURE__*/memo(_ref => {
  let {
    districts,
    isFetching,
    referrer
  } = _ref;
  if (isFetching) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, {
      message: "Kreise werden geladen ...",
      bgColor: false,
      "aria-live": "polite"
    });
  }
  if (!districts.length) {
    return /*#__PURE__*/React.createElement(Placeholder, null, "Es wurden leider keine Regionen gefunden.");
  }
  return /*#__PURE__*/React.createElement(StyledList, null, districts.map(district => /*#__PURE__*/React.createElement("li", {
    key: district.slug
  }, /*#__PURE__*/React.createElement(DistrictLink, {
    district: district,
    referrer: referrer
  }))));
});
export default DistrictList;